import "./Login.scss";
import Auth from "../../components/Auth/Auth";
import { useLogin } from "./logic/useLogin";
import { Spin } from "antd";

function Login() {
  const { handleSubmit, register, errors, onSubmit, loading } = useLogin();

  return (
    <div className="loginPage">
      <Auth title={"Login"} handleSubmitForm={handleSubmit(onSubmit)}>
        <div className="signin-form-control">
          {loading && <Spin size="large" />}

          <label htmlFor="email">Email Address</label>
          <input
            id="email"
            type="text"
            placeholder="Your email address"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i,
                message: "Invalid email address",
              },
            })}
          />
          {errors.email && <p className="error">{errors.email.message}</p>}
        </div>

        <div className="signin-form-control">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            placeholder="Your password"
            {...register("password", {
              required: "Password is required",
              minLength: {
                value: 8,
                message: "Password must be at least 8 characters long",
              },
            })}
          />
          {errors.password && (
            <p className="error">{errors.password.message}</p>
          )}
        </div>

        <div className="password-check">
          <label htmlFor="remember-me" className="remember-me">
            <input id="remember-me" type="checkbox" className="checkbox-box" disabled />{" "}
            Remember Me
          </label>
          <p className="forgot-password">Forgot Password?</p>
        </div>
      </Auth>
    </div>
  );
}

export default Login;
